module.exports = __webpack_public_path__ + "img/ic_feed.37ea9fcc.svg";